import { Component, CUSTOM_ELEMENTS_SCHEMA, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FileUploadItem, ShEditorComponent, ShFileInputComponent } from '@shs-digi-care-monorepo/frontend-lib';
import { DialogWrapperComponent } from '../dialog-wrapper/dialog-wrapper.component';

export type ResolveRequestDialogData = Record<string, never>;
export interface ResolveRequestDialogResult {
    comment: string | null;
    attachments: FileUploadItem[] | null;
}

@Component({
    selector: 'app-resolve-request-dialog',
    templateUrl: './resolve-request-dialog.component.html',
    imports: [
        TranslateModule,
        RouterModule,
        FormsModule,
        ReactiveFormsModule,
        ShEditorComponent,
        ShFileInputComponent,
        DialogWrapperComponent
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class ResolveRequestDialog {
    private readonly dialogRef = inject<MatDialogRef<ResolveRequestDialog>>(MatDialogRef);
    public data = inject<ResolveRequestDialogData>(MAT_DIALOG_DATA);

    protected formGroup = new FormGroup({
        comment: new FormControl<string | null>(null),
        attachments: new FormControl<FileUploadItem[] | null>(null)
    });

    public close(): void {
        this.dialogRef.close();
    }

    public confirm(): void {
        this.dialogRef.close(this.formGroup.value);
    }
}
